import listTemplateUrl from './views/list.tpl.html';
import {ListController} from './controllers/list-controller';

angular
    .module('festzelt-os.modules.exports')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.mo-exports', {
            abstract: true,
            url: '/exports',
            template: '<ui-view/>'
        })
        .state('app.mo-exports.index', {
            url: '',
            controller: ListController,
            controllerAs: 'vm',
            templateUrl: listTemplateUrl
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/exports/routes.js